var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Input',{attrs:{"value":_vm.data,"readonly":_vm.readonly,"roles":_vm.roles},on:{"update":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }